document.addEventListener('DOMContentLoaded', function () {
  const section = document.querySelector('.rv-internet-features');
  const items = Array.from(section.children);
  const total = items.length;

  const scrollMultiplier = 1.2;
  section.style.height = `${100 * (1 + (total - 1) * scrollMultiplier)}vh`;

  function onScroll() {
    const rect = section.getBoundingClientRect();
    const viewportHeight = window.innerHeight;

    const totalScrollable = Math.max(1, section.offsetHeight - viewportHeight);
    let progress = -rect.top / totalScrollable;
    progress = Math.min(Math.max(progress, 0), 1);

    const rawIndex = progress * (total - 1);

    items.forEach((item, i) => {
      const dist = Math.abs(rawIndex - i);
      let opacity = Math.min(1, Math.max(0, 1 - dist / 0.6));

      if (i === 0 && progress <= 0) opacity = 1;
      if (i === total - 1 && progress >= 1) opacity = 1;

      item.style.opacity = opacity;
    });

    if (progress >= 1) {
      section.style.overflow = 'hidden';
      items.forEach(item => {
        item.style.position = 'absolute';
        item.style.top = `${totalScrollable + viewportHeight / 2}px`;
        item.style.transform = 'translate(-50%, -50%)';
      });
    } else if (rect.top <= 0) {
      section.style.overflow = 'hidden';
      items.forEach(item => {
        item.style.position = 'fixed';
        item.style.top = '50%';
        item.style.transform = 'translate(-50%, -50%)';
      });
    } else {
      section.style.overflow = 'hidden';
      items.forEach(item => {
        item.style.position = 'absolute';
        item.style.top = '50%';
        item.style.transform = 'translate(-50%, -50%)';
      });
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  onScroll();
});
